import React, { useEffect } from "react";
import { TopHeading } from "../components/common"
import ClimbingAreasByState from "../components/climbingAreasByState";

interface ForecastByStateAreasProps {
    code?: string
}

const ForecastByStateAreas = (props: ForecastByStateAreasProps) => {

    const code = props.code
    useEffect(() => {
        const tag = code ?? "All"
        document.title = "ClimbingWeather.com - Weather by State - " + tag;
      }, [code]);
    
    return (
        <React.Fragment>
            <TopHeading>Weather by State</TopHeading>
            <div className="box stateAreas">
                <ClimbingAreasByState frontPage={false} code={props.code} />
            </div>
        </React.Fragment>
    )

};

export default ForecastByStateAreas;